// auth/GuestRoute.jsx (Quick fix version)
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Navbar from "../components/landingpage/sections/Navbar";

const GuestRoute = ({ children }) => {
    const authContext = useContext(AuthContext);
    const { user, isLoading } = authContext || {};

    // Show loading state while checking auth
    if (isLoading) {
        return (
            <>
                <Navbar />
                <div className="container-fluid p-0">
                    <div className="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                        <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
                            <div className="col-lg-8 col-md-12 text-center">
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // If user is authenticated, redirect to appropriate dashboard
    if (user) {
        // Check both userType and role for compatibility
        const userRole = user.userType || user.role;

        if (userRole === "fan") {
            return <Navigate to="/" replace />;
        } else if (userRole === "celeb") {
            return <Navigate to="/" replace />;
        }

        // Fallback redirect for other user types
        return <Navigate to="/" replace />;
    }

    // If user is not authenticated, render the login page
    return children;
};

export default GuestRoute;